goog.provide('el8.ptdata.model.med.medOrderDetailsMgr');

goog.require('el8.model.base');
goog.require('el8.ptdata.medOrderFills');
goog.require('el8.ptdata.model.med.interactionsDetail');

el8.ptdata.model.med.medOrderDetailsMgr = function(spec) { this.populate(spec); };
el8.ptdata.model.med.medOrderDetailsMgr.inheritsFrom(el8_Entity); // no id, model_class tho
el8.ptdata.model.med.medOrderDetailsMgr.prototype.populate = function(spec) {
    spec = spec || {};
    if (spec.fills) {
        el8.ptdata.medOrderFills.create(spec.fills, true);
        spec.fill_ids = spec.fills.map(function(a) { return a.id; });
    }
    if (spec.interactions_detail) {
        spec.interactions_detail = new el8.ptdata.model.med.interactionsDetail(spec.interactions_detail);
    }
    el8_Entity.prototype.populate.call(this, spec);
};

el8.ptdata.model.med.medOrderDetailsMgr.addBoolean("responseToControlledRx");
el8.ptdata.model.med.medOrderDetailsMgr.addStringProperty("ssRefillRequestRefNumber");
el8.ptdata.model.med.medOrderDetailsMgr.addProperty("fillIds", false, []);
el8.ptdata.model.med.medOrderDetailsMgr.addProperty("interactionsDetail");
el8.ptdata.model.med.medOrderDetailsMgr.addIntProperty("respondedRefillRequestId");

el8.ptdata.model.med.medOrderDetailsMgr.prototype.asSoyMap = function() {
    var m = {};
    var that = this;
    
    var fillMaps = [];
    this.getFillIds().forEach(function(id) {
        var fill = el8.ptdata.medOrderFills.getById(id);
         // formerly virtual fills won't exist anymore
        if (fill) { fillMaps.push(fill.asSoyMap()); }
    });
    m['fills'] = fillMaps;
    m['ssRefillRequestRefNumber'] = this.getSsRefillRequestRefNumber();
    m['responseToControlledRx'] = this.isResponseToControlledRx();
    m['interactionsDetail'] = this.getInteractionsDetail() ?
        this.getInteractionsDetail().asSoyMap() : null;
    return m;
};


